import React, { FormEvent } from "react";
import { Link } from "react-router-dom";
import Services, { Service } from "../../api/service";
import blogs, { Blog } from "../../api/blogs";

// 🧩 Props Interface
interface BlogSidebarProps {
  blLeft?: boolean;
}

// 🧠 Component
const BlogSidebar: React.FC<BlogSidebarProps> = ({ blLeft }) => {
  // 📝 Handlers
  const SubmitHandler = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
  };

  const ClickHandler = (): void => {
    window.scrollTo(10, 0);
  };

  return (
    <div className="blog-sidebar">
      {/* 🔍 Search Widget */}
      <div className="widget search-widget">
        <h3>Search Here</h3>
        <form onSubmit={SubmitHandler}>
          <div>
            <input
              type="text"
              className="form-control"
              placeholder="Search Post.."
            />
            <button type="submit" aria-label="Search">
              <i className="ti-search"></i>
            </button>
          </div>
        </form>
      </div>

      {/* 🗂 Categories Widget */}
      <div className="widget category-widget">
        <h3>Categories</h3>
        <ul>
          {Services.slice(0, 6).map((service: Service, index: number) => (
            <li key={service.id || index}>
              <Link
                onClick={ClickHandler}
                to={`/service-single/${service.slug}`}
              >
                {service.title} <span>({service.id})</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* 📰 Related Posts Widget */}
      <div className="widget recent-post-widget">
        <h3>Related Posts</h3>
        <div className="posts">
          {blogs.slice(0, 3).map((blog: Blog, index: number) => (
            <div className="post" key={blog.id || index}>
              <div className="img-holder">
                <img src={blog.screens} alt={blog.title} />
              </div>
              <div className="details">
                <h4>
                  <Link
                    onClick={ClickHandler}
                    to={`/blog-single/${blog.slug}`}
                  >
                    {blog.title}
                  </Link>
                </h4>
                <span className="date">{blog.create_at}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 🏷️ Popular Tags Widget */}
      <div className="widget tag-widget">
        <h3>Popular Tags:</h3>
        <ul>
          {[
            "photography",
            "Planning",
            "wedding",
            "events",
            "creative",
            "Solution",
            "collection",
            "Idea",
            "bride & groom",
          ].map((tag, index) => (
            <li key={index}>
              <Link
                onClick={ClickHandler}
                to={`/blog-single/Make-sure-your`}
              >
                {tag}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default BlogSidebar;
